import React from 'react'
import { Route } from 'react-router-dom'
import PropTypes from 'prop-types'

function PublicRoute({ children, ...restRouteProps }) {
  return <Route {...restRouteProps}>{children}</Route>
}

PublicRoute.propTypes = {
  children: PropTypes.element
}

export default PublicRoute
